/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AnalyticsReportType {
    EMPLOYEE_COMPOSITE = 'EmployeeComposite',
    MARKET_PRICE = 'MarketPrice',
    JOB_MAPPING = 'JobMapping',
    EMPLOYEE_COMPOSITE_RANGE_MODEL = 'EmployeeCompositeRangeModel',
    RANGE_MODEL_COMPOSITE = 'RangeModelComposite',
    UNKNOWN = 'Unknown',
}
